/** Default voice talent to use when none is set. */
export const defaultVoiceTalent = 'Phil';
